module.exports = __webpack_public_path__ + "static/media/FIN.401a01ec.svg";